<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="From"><br>
                                            <a-range-picker @change="create_job = 0, create_job_sql = []" v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                        </base-input>
                                    </div>
                                </div>
                                <div class="row" v-if="site_type == 'ho'">
                                    <div class="col-md-7">
                                        <base-input label="Location">
                                            <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" changeOnSelect/>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                            <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                                <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <!-- <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                    <div class="col-md-7">
                                        <base-input label="Group By" >
                                            <select class="form-control" v-model="inputGroup">
                                                <option v-for="option in groupByOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div> -->
            
                                
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Sort By" >
                                            <select class="form-control" v-model="inputSortBy">
                                                <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                    <div class="col-md-2 mt-3 pt-3">
                                        <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                            {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                        </button>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Status" >
                                            <select class="form-control" :disabled="this.$attrs.friendlyCode=='RECPOS'" size="large" v-model="inputStatus">
                                                <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Format" >
                                            <select class="form-control" size="large" v-model="inputFormat">
                                                <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                    <div class="col-md-7"> 
                                        <base-input alternative="" label="Customer">
                                            <a-select mode="multiple" v-model="inputCustomers" showSearch placeholder="All Customers" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in customerOptions" :key="option.id" :value="option.id">{{option.name || option.code}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                  <div class="col-md-7">
                                    <base-input alternative="">
                                      <a-checkbox v-model="showOrderReference">Show Order Reference</a-checkbox>
                                    </base-input>
                                  </div>
                                </div>

                                <div class="row" v-if="currentProfile == 'pos_sales_journals'">
                                  <div class="col-md-7">
                                    <base-input alternative="">
                                      <a-checkbox v-model="showERPCode">Show ERP Code</a-checkbox>
                                    </base-input>
                                  </div>
                                </div>



                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                </div>
            </div>
    
            <div class="row">
                <div class="col-md-12" style="margin-bottom: 20px;">
                    <br>
                    <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                    <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                    <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                        <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                    </vue-json-to-csv>
                    <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                </div>
            </div>
        </div>
    </a-spin>
</template>
<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                get_request: [],
                spinning: false,
                is_create_job: 0,
                create_job: 0,
                create_job_sql: [],
                create_job_params: [],
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                currDate: moment().format("L_LT").split(":").join(";"),
                inputStatus: 'P',
                showOrderReference: false,
                showERPCode: false,
                // inputGroup: '',
                // groupByOptions: [
                //     {key: '', value: 'No Grouping'},
                //     {key: 'customer', value: 'Customer'},
                // ],
                inputCustomers: [],
                cutomerOptions: [],
                statusOptions: [
                    {key: 'A', value: 'Aborted'},
                    {key: 'P', value: 'Posted'},
                    {key: 'V', value: 'Voided'}
                ],
                formatOptions: [
                    {key: '1', value: 'Simple'},
                    {key: '2', value: 'Extended'}
                ],
                inputFormat: 1,
                inputSortBy: 'terminal_id',
                sortOptions: [
                    {key: 'terminal_id', value: 'Terminal'},
                    {key: 'user_id', value: 'Cashier'},
                    {key: 'document_customer_name', value: 'Customer'},
                    {key: 'trans_id', value: 'Trans ID'},
                ],
                transOptions: [
                    {key: "RELPOS", value: "POS Sales"},
                    {key: "OROPOS", value: "POS Reservations"},
                    {key: "RECPOS", value: "POS Returns"},
                ],
                inputSite: [],
                site_type: "ho",
                showSortInfo: 'asc',
                
                checkedDetailFields: ["product_id","trans_id" ,"stock_no", "barcode", "product_name", "quantity"],
                checkedHeaderFields: ["id", "document_date", "posted_at", "origin_document_id", "origin_document_date", "status"],
                
                siteOptions: [],
                birSalesReports: [],
                JsonData: [],
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: '',
                inputLocation:[],
                locationOptions: [],
                customerOptions: []
            }
        },
        mounted: async function () {
            var component_x = this;

            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            var customer = await HTTPRequest.getRequest(component_x.endPoint + "customers/get_valid_customers?mode=all", null);
            component_x.customerOptions = customer;
            component_x.sort(component_x.customerOptions);

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            if(this.$attrs.friendlyCode=='RECPOS'){
                this.inputStatus = "R"
                this.statusOptions.push({key: 'R', value: 'Return'})
            }else {
                this.inputStatus = "P"
                this.statusOptions = [{key: 'A', value: 'Aborted'},{key: 'P', value: 'Posted'},{key: 'V', value: 'Voided'}]
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            convertToCurrencyForExcel(num){
                return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            openNotificationWithIcon(type, msg, hdrmsg) {
                this.$notification[type]({
                    message: hdrmsg,
                    description: msg 
                });
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            monthDiff(date1,date2,roundUpFractionalMonths) {
                //Months will be calculated between start and end dates.
                //Make sure start date is less than end date.
                //But remember if the difference should be negative.
                var startDate=date1;
                var endDate=date2;
                var inverse=false;
                if(date1>date2)
                {
                    startDate=date2;
                    endDate=date1;
                    inverse=true;
                }

                //Calculate the differences between the start and end dates
                var yearsDifference=endDate.getFullYear()-startDate.getFullYear();
                var monthsDifference=endDate.getMonth()-startDate.getMonth();
                var daysDifference=endDate.getDate()-startDate.getDate();
                var monthCorrection=0;
                //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
                //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
                if(roundUpFractionalMonths===true && daysDifference>0)
                {
                    monthCorrection=1;
                }
                //If the day difference between the 2 months is negative, the last month is not a whole month.
                else if(roundUpFractionalMonths!==true && daysDifference<0)
                {
                    monthCorrection=-1;
                }

                return (inverse?-1:1)*(yearsDifference*12+monthsDifference+monthCorrection);
            },
            async createJob() {
                //Create JOB
                var jobPayload = {
                    sql: this.create_job_sql,
                    params: this.create_job_params
                }
                this.spinning= true;
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'report_job/create_job', null, jobPayload)
                if(post_request['msg'] != undefined){
                    this.openNotificationWithIcon('info', post_request['msg'], 'Create Job');
                    this.create_job = 0
                    this.create_job_sql = []
                    this.spinning= false;
                    return
                } else {
                    this.openNotificationWithIcon('error', post_request['error'], 'Create Job');
                    this.spinning= false;
                    return
                }
            },
            validateFilters: async function () {
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Date is required.', 'Generate Report');
                    this.spinning= false;
                    return
                }

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                // let group = '';
                let customers = '';
                if(this.currentProfile == 'pos_sales_journals'){
                    // group = this.inputGroup;
                    customers = this.inputCustomers; 
                }
                var validate_job_params = []
                //Check if filter is greater or equal to 6 months
                this.is_create_job = 0

                if((this.monthDiff(new Date(this.inputDate[0].format('MM DD, YYYY')), new Date(this.inputDate[1].format('MM DD, YYYY')), true)) > 5){
                    this.is_create_job = 1
                    validate_job_params = await HTTPRequest.getRequest(this.endPoint + 'report_job/validate_job?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&is_create_job=' + this.is_create_job + '&customer=' + customers, null);
                }

                this.get_request = await HTTPRequest.getRequest(this.endPoint + 'pos_operation_report?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&type=' + this.$attrs.friendlyCode + '&status=' + this.inputStatus + '&is_create_job=' + this.is_create_job + '&customer=' + customers, null);

                if(validate_job_params.length > 0 && this.is_create_job == 1) {
                    if(['Q','P','X'].includes(validate_job_params[0].status) && validate_job_params[0].created_by == secureStorage.getItem("userCode")){
                        this.openNotificationWithIcon('error', 'You have already queued a report with the same filter. Please wait for the email.', 'Generate Report');
                        this.spinning= false;
                        return
                    }
                    var s3_links = JSON.parse(validate_job_params[0].s3_path)
                    this.$confirm({
                        title: 'Confirmation',
                        content: h => <div>Filter is beyond limit, this will process via jobs and automatically send the report to your registered email address.<br/> Click Create Job button to proceed. <br/><br/>Or use the existing report data with the same filter processed by <b>{validate_job_params[0].created_by} </b>last <b>{validate_job_params[0].created_at}</b>.<br/><br/><a href={s3_links.s3_pdf} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-pdf"></i> PDF</a> | <a href={s3_links.s3_xls} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-excel"></i> EXCEL</a> | <a href={s3_links.s3_csv} class="font-weight-bold ml-1" target="_blank"><i class="fa fa-file-csv"></i> CSV</a></div>,
                        okText: 'Create Job',
                        onOk: () => {
                                    this.create_job = true;
                                    this.create_job_sql = this.get_request
                                    this.create_job_params = {
                                        report_type: this.$attrs.friendlyCode,
                                        site_id: this.inputSite,
                                        date_from: from_date,
                                        date_to: to_date,
                                        order: this.inputSortBy,
                                        by: this.showSortInfo,
                                        status: this.inputStatus,
                                        format: this.inputFormat
                                    }
                                    this.createJob()
                                    },
                        onCancel() {}
                    });

                            this.spinning= false;
                            return
                } else if(validate_job_params.length == 0 && this.is_create_job == 1){
                    this.$confirm({
                            title: 'Confirmation',
                            content: h => <div>Filter is beyond limit, this will process via jobs and automatically send the report to your registered email address. Click Create Job button to proceed.</div>,
                            okText: 'Create Job',
                            onOk: () => {
                                    this.create_job = true;
                                    this.create_job_sql = this.get_request
                                    this.create_job_params = {
                                        report_type: this.$attrs.friendlyCode,
                                        site_id: this.inputSite,
                                        date_from: from_date,
                                        date_to: to_date,
                                        order: this.inputSortBy,
                                        by: this.showSortInfo,
                                        status: this.inputStatus,
                                        format: this.inputFormat
                                    }
                                    this.createJob()
                            },
                            onCancel() {}
                            });

                    this.spinning= false;
                    return
                }
                this.spinning= false;
            },
            async onLocationChange(){
                var location = this.inputLocation[this.inputLocation.length - 1]
                if(!location){
                    this.handleClearInputLocation()
                }else {
                    this.siteOptions = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                    this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                    this.inputSite = this.siteOptions.map( s => s.id);
                }
                
            },
            async handleClearInputLocation() {
                var userId = secureStorage.getItem("userId");
                var sites = await HTTPRequest.getRequest(this.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                this.siteOptions = sites;
                this.sort(this.siteOptions);
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)
                let siteId = secureStorage.getItem("defaultSiteId");
                this.inputSite = [siteId]
            },
            generateReport: async function () {
                this.spinning= true;
                await this.validateFilters();

                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                let no_subtotal = ["barcode", "stock_no", "product_name", "tax_rate", "created_at", "updated_at", "discount_text", "remarks", "customer_remark"]
                
                var siteSpecific = this.get_request;
                let reportLogo = document.getElementById('reportLogo');

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }
                    
                    let headers = [];
                    let header_detail = [];
                    let simpleplus = 0
                    let spanplus = 0
                    if( this.inputFormat == 2 ) {
                        simpleplus = 5
                        spanplus = 1
                    }
                    let erpSpanPlus = this.showERPCode === true ? 1 : 0;
                    header_detail.push( 
                        {content: 'Terminal', styles: {halign: 'left', valign: 'center'}},
                        {content: 'Date', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Trans #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'SI #', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Customer', colSpan: 2 + spanplus, styles: {halign: 'center', valign: 'center'}},
                        {content: 'References', colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Remarks', colSpan: 2 + spanplus, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Customer Remarks', colSpan: 3 + spanplus + erpSpanPlus, styles: {halign: 'center', valign: 'center'}}
                        )

                    headers = [header_detail]
                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_gross_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_gross_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            let trans_grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name
                                let current_trans_id = reportLine.trans_id
                                
                                if(grouper == 'start'){
                                    let h_detail = [
                                        {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                        {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: reportLine.document_customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.remarks + "").replace("null", ""), colSpan: 2, styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                        {content: (reportLine.customer_remark + "").replace("null", ""), colSpan: 3 + erpSpanPlus, styles: {halign: 'center', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, h_detail))
                                    let cashier_detail = [
                                        {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                    ];
                                    reportData.push(Object.assign({}, cashier_detail))
                                    let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                    if (this.showERPCode === true) {
                                        detail_header.push({content: 'ERP Code', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}});
                                    }
                                    detail_header = detail_header.concat([
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Gross Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ]);
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                    reportData.push(Object.assign({}, detail_header))
                                    trans_grouper = current_trans_id
                                } else {
                                    // Check if grouper changed (main group) OR trans_id changed (sub-group within terminal/cashier/customer)
                                    let showNewHeader = (grouper != grouper_name) || (this.inputSortBy != 'trans_id' && trans_grouper != current_trans_id)
                                    if(showNewHeader){
                                        // Show subtotal for previous transaction when trans_id changes within the same group
                                        if(this.inputSortBy != 'trans_id' && trans_grouper != current_trans_id){
                                            // Only print subtotal if there are accumulated values (avoid duplicate 0-value subtotal
                                            // when main group also changed and subtotal was already printed by end-of-loop block)
                                            if(sub_total_qty != 0 || sub_total_amount != 0 || sub_total_gross_amount != 0){
                                                reportData.push(Object.assign({}, ["rowLine"]))
                                                let transSubTotalRow = ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_gross_amount)), 'Y'), this.convertToCurrency(Number(sub_total_disc)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                                    ];
                                                if (this.showERPCode === true) { transSubTotalRow.splice(3, 0, ''); }
                                                reportData.push(Object.assign({}, transSubTotalRow));
                                            }
                                            sub_total_qty = 0
                                            sub_total_amount = 0
                                            sub_total_gross_amount = 0
                                            sub_total_cost = 0
                                            sub_total_markup = 0
                                            sub_total_disc = 0
                                            sub_total_srp = 0
                                            sub_total_net_price = 0
                                            sub_total_ave_price = 0
                                            sub_cost = 0
                                        } else if(grouper != grouper_name){
                                            // Main group changed - subtotal was already printed by the end-of-loop else block
                                            // Just reset counters here (no duplicate print needed)
                                            sub_total_qty = 0
                                            sub_total_amount = 0
                                            sub_total_gross_amount = 0
                                            sub_total_cost = 0
                                            sub_total_markup = 0
                                            sub_total_disc = 0
                                            sub_total_srp = 0
                                            sub_total_net_price = 0
                                            sub_total_ave_price = 0
                                            sub_cost = 0
                                        }
                                        let h_detail = [
                                            {content: reportLine.terminal_name, styles: {halign: 'left', fontStyle: 'bold'}},
                                            {content: moment(String(reportLine.document_date)).format('MM/DD/YYYY hh:mm'), styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.trans_id, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.invoice_no, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: reportLine.document_customer_name, colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.reference_code1 + "").replace("null", ""), colSpan: 2 + spanplus, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.remarks + "").replace("null", ""), colSpan: 2, styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: "", styles: {halign: 'center', fontStyle: 'bold'}},
                                            {content: (reportLine.customer_remark + "").replace("null", ""), colSpan: 3 + erpSpanPlus, styles: {halign: 'center', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, h_detail))
                                        let cashier_detail = [
                                            {content: 'Cashier: ' + reportLine.cashier, colSpan: 4, styles: {halign: 'left', fontStyle: 'bold'}}
                                        ];
                                        reportData.push(Object.assign({}, cashier_detail))
                                        let detail_header = [
                                            {content: 'Product Code', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Barcode', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Description', styles: {halign: 'left', valign: 'center', fontStyle: 'bold'}},
                                            ];
                                        if (this.showERPCode === true) {
                                            detail_header.push({content: 'ERP Code', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}});
                                        }
                                        detail_header = detail_header.concat([
                                            {content: 'Quantity', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'SRP', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Net Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Ave Price', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Gross Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Discount', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Amt.', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            {content: 'Total Cost', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                            ]);
                                            if( this.inputFormat == 2 ) {
                                                detail_header.push(
                                                    {content: 'MarkUp', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}},
                                                    {content: 'MarkUp%', styles: {halign: 'center', valign: 'center', fontStyle: 'bold'}}
                                                )
                                            }
                                        reportData.push(Object.assign({}, detail_header))
                                        trans_grouper = current_trans_id
                                    }
                                }
                                grouper = grouper_name

                                    let detail = [
                                        reportLine.product_id,
                                        reportLine.barcode,
                                        reportLine.product_name,
                                    ]
                                    if (this.showERPCode === true) {
                                        let erpCode = String(reportLine.erp_code || "");
                                        detail.push(erpCode.substring(0, 9));
                                    }
                                    detail = detail.concat([
                                        this.convertToCurrency(Number(reportLine.quantity)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.original_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.net_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.ave_price)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.gross_amt)), 'Y'),
                                        this.convertToCurrency(Number(reportLine.discount)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.subtotal)), 'Y'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.total_cost)), 'Z')
                                    ])

                                let markup_display = 0
                                let markup_percent_display = 0
                                if(this.inputFormat == '2'){
                        
                                    markup_display = Number(reportLine.markup_display)

                                    if( Number(reportLine.total_cost) != 0)
                                        markup_percent_display = Number(reportLine.markup_percent_display)
                                    else 
                                        markup_percent_display = Number(0)
                                    
                                    detail.push(
                                        this.convertToCurrency(Number(markup_display)),
                                        this.convertToCurrency(Number(markup_percent_display))
                                    )     
                                }

                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.subtotal)
                                sub_total_gross_amount += Number(reportLine.gross_amt)
                                sub_total_cost += Number(reportLine.total_cost)
                                sub_total_markup += Number(reportLine.markup_display)
                                sub_total_disc += Number(reportLine.discount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.net_price)
                                sub_total_ave_price += Number(reportLine.ave_price)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.subtotal)
                                grand_total_gross_amount += Number(reportLine.gross_amt)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_total_markup += Number(reportLine.markup_display)
                                grand_total_disc += Number(reportLine.discount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.net_price)
                                grand_total_ave_price += Number(reportLine.ave_price)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))
                    
                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    let subTotalRow3 = ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_gross_amount)), 'Y'), this.convertToCurrency(Number(sub_total_disc)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                        ];
                                    if (this.showERPCode === true) { subTotalRow3.splice(3, 0, ''); }
                                    reportData.push(Object.assign({}, subTotalRow3));
                
                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    let grandTotalRow = ['', '', 'Grand Total :', this.convertToCurrency(Number(grand_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrency(Number(grand_total_gross_amount)), 'Y'), this.convertToCurrency(Number(grand_total_disc)), this.addMaskValidation(this.convertToCurrency(Number(grand_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(grand_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(grand_total_markup)) : '' )
                                            ];
                                    if (this.showERPCode === true) { grandTotalRow.splice(3, 0, ''); }
                                    reportData.push(Object.assign({}, grandTotalRow));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = grouper_name
                                    next_grouper = this.birSalesReports[i+1].grouper_name

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        let subTotalRow4 = ['', '', 'Sub Total :', this.convertToCurrency(Number(sub_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_gross_amount)), 'Y'), this.convertToCurrency(Number(sub_total_disc)), this.addMaskValidation(this.convertToCurrency(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrency(Number(sub_total_cost)), 'Z'), ((this.inputFormat == '2') ? this.convertToCurrency(Number(sub_total_markup)) : '' )
                                            ];
                                        if (this.showERPCode === true) { subTotalRow4.splice(3, 0, ''); }
                                        reportData.push(Object.assign({}, subTotalRow4));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_gross_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                                    
                            }
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,trans_val + " Journal By " + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(8);
    
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        
                        doc.text(15,25,"For the Period of " + from_date + " to " + to_date)

                        let colStyles = {}
                        if (this.showERPCode === true) {
                            colStyles = {
                                0: {cellWidth: 28},
                                1: {cellWidth: 35},
                                2: {cellWidth: 25},
                                3: {cellWidth: 45},
                                4: {cellWidth: 21 - simpleplus},
                                5: {cellWidth: 21 - simpleplus},
                                6: {cellWidth: 21 - simpleplus},
                                7: {cellWidth: 21 - simpleplus},
                                8: {cellWidth: 21 - simpleplus},
                                9: {cellWidth: 21 - simpleplus},
                                10: {cellWidth: 21 - simpleplus},
                                11: {cellWidth: 21 - simpleplus},
                                12: {cellWidth: 21 - simpleplus},
                            }
                            if (this.inputFormat == '2') {
                              colStyles = {
                                ...colStyles,
                                13: {cellWidth: 18},
                                14: {cellWidth: 18}
                              }
                            }
                        } else {
                            colStyles = {
                                0: {cellWidth: 30},
                                1: {cellWidth: 40},
                                2: {cellWidth: 50},
                                3: {cellWidth: 23 - simpleplus},
                                4: {cellWidth: 23 - simpleplus},
                                5: {cellWidth: 23 - simpleplus},
                                6: {cellWidth: 23 - simpleplus},
                                7: {cellWidth: 23 - simpleplus},
                                8: {cellWidth: 23 - simpleplus},
                                9: {cellWidth: 23 - simpleplus},
                                10: {cellWidth: 23 - simpleplus},
                                11: {cellWidth: 23 - simpleplus},
                            }
                            if (this.inputFormat == '2') {
                              colStyles = {
                                ...colStyles,
                                12: {cellWidth: 18},
                                13: {cellWidth: 18}
                              }
                            }
                        }
                        
                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });
                    
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportUtils.pdfTools.addFooter(doc, printed_by, trans_val + " Journal By " + group_text, 340, 200, x+1, siteSpecific.length)

                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else if(this.is_create_job == 0) {
                    this.openNotificationWithIcon('warning', 'No data to export.', 'Generate Report');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                await this.validateFilters();
                
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                let siteSpecific = this.get_request;

                if(siteSpecific.length > 0){
                    let trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
                    let headers = ['Terminal',' Date','Posted At','Voided At',' Trans #',' SI #',' Customer',' References',' Remarks', 'Customer Remarks', ' Product Code',' Barcode',' Descriptions',' Quantity',' SRP',' Net Price',' Average Price',' Gross Amt',' Discount',' Total Amt',' Cost',' Total Cost',' MarkUp',' MarkUp%'];
                    
                    if (this.showOrderReference === true) {
                      const customerIndex = headers.indexOf(' Customer');
                      if (customerIndex !== -1) {
                        headers.splice(customerIndex + 1, 0, 'Job Order Number');
                      }
                    }

                    if (this.showERPCode === true) {
                      const descIndex = headers.indexOf(' Descriptions');
                      if (descIndex !== -1) {
                        headers.splice(descIndex + 1, 0, ' ERP Code');
                      }
                    }

                    let site_specific = [];
                    let group_text = ""
                    if(this.inputSortBy != ''){
                        group_text = this.sortOptions.find(x => x.key === this.inputSortBy).value
                    }

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }

                        if(this.birSalesReports.length > 0){
                            let sub_total_qty = 0
                            let sub_total_amount = 0
                            let sub_total_gross_amount = 0
                            let sub_total_cost = 0
                            let sub_total_markup = 0
                            let sub_total_disc = 0
                            let sub_total_srp = 0
                            let sub_total_net_price = 0
                            let sub_total_ave_price = 0
                            let sub_cost = 0
                            let grand_total_qty = 0
                            let grand_total_amount = 0
                            let grand_total_gross_amount = 0
                            let grand_total_cost = 0
                            let grand_total_markup = 0
                            let grand_total_disc = 0
                            let grand_total_srp = 0
                            let grand_total_net_price = 0
                            let grand_total_ave_price = 0
                            let grand_cost = 0
                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [group_text + ' : ' + grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [group_text + ' : ' + grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let markup_display = 0
                                let markup_percent_display = 0

                                markup_display = Number(reportLine.markup_display)

                                if( Number(reportLine.total_cost) != 0)
                                    markup_percent_display = Number(reportLine.markup_percent_display)
                                else 
                                    markup_percent_display = Number(0)

                                let detail = [
                                  String(reportLine.terminal_name),
                                  moment(String(reportLine.document_date)).format('MM/DD/YYYY HH:mm A'),
                                  reportLine.posted_at ? moment(String(reportLine.posted_at)).format('MM/DD/YYYY HH:mm A') : "-",
                                  reportLine.void_date ? moment(String(reportLine.void_date)).format('MM/DD/YYYY HH:mm A') : "-",
                                  String(reportLine.trans_id),
                                  String(reportLine.invoice_no),
                                  String(reportLine.document_customer_name),
                                ];

                                if (this.showOrderReference === true) {
                                  detail.push(reportLine.order_reference_code != null ? String(reportLine.order_reference_code) : "");
                                }

                                detail = detail.concat([
                                  (reportLine.reference_code1 + "").replace("null", ""),
                                  (reportLine.remarks + "").replace("null", ""),
                                  (reportLine.customer_remark + "").replace("null", ""),
                                  String(reportLine.product_id),
                                  String(reportLine.barcode),
                                  String(reportLine.product_name),
                                ]);

                                if (this.showERPCode === true) {
                                    let erpCode = String(reportLine.erp_code || "");
                                    detail.push(erpCode.substring(0, 9));
                                }

                                detail = detail.concat([
                                  this.convertToCurrencyForExcel(Number(reportLine.quantity)),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.original_price)), 'Y'),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.net_price)), 'Y'),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.ave_price)), 'Y'),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.gross_amt)), 'Y'),
                                  this.convertToCurrencyForExcel(Number(reportLine.discount)),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.subtotal)), 'Y'),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.cost)), 'Z'),
                                  this.addMaskValidation(this.convertToCurrencyForExcel(Number(reportLine.total_cost)), 'Z'),
                                  this.convertToCurrencyForExcel(Number(markup_display)),
                                  this.convertToCurrencyForExcel(Number(markup_percent_display))
                                ]);

                                // sub_total_qty += Number(reportLine.quantity)
                                // sub_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // sub_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // sub_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                // grand_total_qty += Number(reportLine.quantity)
                                // grand_total_amount += Number(reportLine.original_price * reportLine.quantity)
                                // grand_total_cost += Number(reportLine.cost * reportLine.quantity)
                                // grand_total_markup += Number(reportLine.original_price * reportLine.quantity) - Number(reportLine.cost * reportLine.quantity)
                                sub_total_qty += Number(reportLine.quantity)
                                sub_total_amount += Number(reportLine.subtotal)
                                sub_total_gross_amount += Number(reportLine.gross_amt)
                                sub_total_cost += Number(reportLine.total_cost)
                                sub_total_markup += Number(reportLine.markup_display)
                                sub_total_disc += Number(reportLine.discount)
                                sub_total_srp += Number(reportLine.original_price)
                                sub_total_net_price += Number(reportLine.net_price)
                                sub_total_ave_price += Number(reportLine.ave_price)
                                sub_cost += Number(reportLine.cost)
                                
                                grand_total_qty += Number(reportLine.quantity)
                                grand_total_amount += Number(reportLine.subtotal)
                                grand_total_gross_amount += Number(reportLine.gross_amt)
                                grand_total_cost += Number(reportLine.total_cost)
                                grand_total_markup += Number(reportLine.markup_display)
                                grand_total_disc += Number(reportLine.discount)
                                grand_total_srp += Number(reportLine.original_price)
                                grand_total_net_price += Number(reportLine.net_price)
                                grand_total_ave_price += Number(reportLine.ave_price)
                                grand_cost += Number(reportLine.cost)

                                reportData.push(Object.assign({}, detail))

                                if(i == this.birSalesReports.length-1){
                                    //Subtotal
                                    let subTotalEmptyCols = ['', '', '', '', '', '', '', '', '', '', '', '', 'Subtotal : '];
                                    if (this.showOrderReference === true) { subTotalEmptyCols.splice(7, 0, ''); }
                                    if (this.showERPCode === true) { subTotalEmptyCols.splice(subTotalEmptyCols.length - 1, 0, ''); }
                                    let subTotalDataCols = [this.convertToCurrencyForExcel(Number(sub_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_gross_amount)), 'Y'), this.convertToCurrencyForExcel(Number(sub_total_disc)), this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_cost)), 'Z'), this.convertToCurrencyForExcel(Number(sub_total_markup))];
                                    reportData.push(Object.assign({}, subTotalEmptyCols.concat(subTotalDataCols)));
                
                                    //Grand Total
                                    let grandTotalEmptyCols = ['', '', '', '', '', '', '', '', '', '', '', '', 'Grand total : '];
                                    if (this.showOrderReference === true) { grandTotalEmptyCols.splice(7, 0, ''); }
                                    if (this.showERPCode === true) { grandTotalEmptyCols.splice(grandTotalEmptyCols.length - 1, 0, ''); }
                                    let grandTotalDataCols = [this.convertToCurrencyForExcel(Number(grand_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(grand_total_gross_amount)), 'Y'), this.convertToCurrencyForExcel(Number(grand_total_disc)), this.addMaskValidation(this.convertToCurrencyForExcel(Number(grand_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(grand_total_cost)), 'Z'), this.convertToCurrencyForExcel(Number(grand_total_markup))];
                                    reportData.push(Object.assign({}, grandTotalEmptyCols.concat(grandTotalDataCols)));
                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        //Subtotal
                                        let midSubTotalEmptyCols = ['', '', '', '', '', '', '', '', '', '', '', '', 'Subtotal : '];
                                        if (this.showOrderReference === true) { midSubTotalEmptyCols.splice(7, 0, ''); }
                                        if (this.showERPCode === true) { midSubTotalEmptyCols.splice(midSubTotalEmptyCols.length - 1, 0, ''); }
                                        let midSubTotalDataCols = [this.convertToCurrencyForExcel(Number(sub_total_qty)), '', '', '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_gross_amount)), 'Y'), this.convertToCurrencyForExcel(Number(sub_total_disc)), this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_amount)), 'Y'), '', this.addMaskValidation(this.convertToCurrencyForExcel(Number(sub_total_cost)), 'Z'), this.convertToCurrencyForExcel(Number(sub_total_markup))];
                                        reportData.push(Object.assign({}, midSubTotalEmptyCols.concat(midSubTotalDataCols)));

                                        sub_total_qty = 0
                                        sub_total_amount = 0
                                        sub_total_gross_amount = 0
                                        sub_total_cost = 0
                                        sub_total_markup = 0
                                        sub_total_disc = 0
                                        sub_total_srp = 0
                                        sub_total_net_price = 0
                                        sub_total_ave_price = 0
                                        sub_cost = 0
                                    }
                                }
                            }

                        }

                        let site_text = ''
                        if(this.inputSite.length == 0){
                            site_text = 'All Sites'
                        } else {
                            let sites = this.inputSite
                            for (var s = 0; s < sites.length; s++) {
                                if(s == 0){
                                    site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                } else {
                                    site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                }
                            }
                        }
                        reportData.unshift([site_text]);
                        
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        reportData.push([])
                        reportData.push([trans_val + " Journal By " + group_text, "Generated By: " + printed_by,"For the Period of " + from_date + " to " + to_date])
                        reportData.push([])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else if(this.is_create_job == 0) {
                    this.openNotificationWithIcon('warning', 'No data to export.', 'Generate Report');
                }
                this.spinning= false;
            },

            clearJsonData(){
              this.JsonData = [];
            },
            generateExcel(){
              if(this.JsonData.length === 0) return

              const workbook = new ExcelJS.Workbook();
              workbook.created = new Date();
              workbook.modified = new Date();

              const trans_val = this.transOptions.find(x => x.key === this.$attrs.friendlyCode).value
              const sheet = workbook.addWorksheet(trans_val + " Journal", {
                pageSetup:{paperSize: 9}
              });

              // Get headers from JsonData keys
              const headers = Object.keys(this.JsonData[0])
              sheet.getRow(1).values = headers
              sheet.getRow(1).font = { bold: true }

              // Define amount column headers that need currency formatting
              const amountHeaders = [' SRP', ' Net Price', ' Average Price', ' Gross Amt', ' Discount', ' Total Amt', ' Cost', ' Total Cost', ' MarkUp', ' MarkUp%']

              // Set column widths
              sheet.columns = headers.map(h => ({ key: h, width: 18 }))

              // Add data rows with proper numeric values for amount columns
              for(let i = 0; i < this.JsonData.length; i++){
                const row = this.JsonData[i]
                const rowData = {}
                headers.forEach(header => {
                  const val = row[header]
                  if(amountHeaders.includes(header) && val !== '' && val !== undefined && val !== null && val !== '***'){
                    const parsed = Number(String(val).replace(/,/g, ''))
                    rowData[header] = isNaN(parsed) ? 0 : parsed
                  } else {
                    rowData[header] = val !== undefined && val !== null ? val : ''
                  }
                })
                sheet.addRow(rowData)
              }

              // Apply number format to amount columns
              const amountNumFmt = '#,##0.00'
              const amountColIndices = []
              headers.forEach((h, idx) => {
                if(amountHeaders.includes(h)){
                  amountColIndices.push(idx + 1) // 1-indexed
                }
              })

              sheet.eachRow(function (Row, rowNum) {
                if(rowNum > 1){
                  Row.eachCell(function (Cell, colNumber) {
                    if(amountColIndices.includes(colNumber)){
                      Cell.numFmt = amountNumFmt
                    }
                    Cell.alignment = { vertical: 'middle', horizontal: 'left' }
                  })
                } else {
                  Row.eachCell(function (Cell) {
                    Cell.alignment = { horizontal: 'center' }
                  })
                }
              })

              const component_x = this
              const fileName = this.currentProfile.replace(/_/g, '-') + '-' + this.currDate.replace(/ /g, '') + '.xlsx'
              workbook.xlsx.writeBuffer().then(function(buffer) {
                const blob = new Blob([buffer], { type: "application/xlsx" });
                saveAs(blob, fileName);
                component_x.JsonData = [];
              });
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            },
              // bryan
              selectLocationFunction(){
              if(this.inputSite.length !== 0){
                this.inputSite = []
              }
              this.siteOptions.map(({location_name, id}) => {
                if(location_name === this.selectedLocation){
                  this.inputSite = [...this.inputSite, id]
                }
              })
            }
        },
    };
</script>

<style></style>
